import { useState } from "react";
import './ReportDescription.css'
export const ReportDescription = ({ title, description }) => {
    const [expanded, setExpanded] = useState(false);
    const toggleExpand = () => setExpanded((prev) => !prev);

    const maxLength = 80;
    const isLong = description?.length > maxLength;
    const shortText = description?.slice(0, maxLength) + '...';

    return (
        <div className="report-assign-description-container">
            <h4 className="report-assign-description-title">{title ? title : 'Description'}</h4>
            <p className={`report-assign-description-text ${expanded ? 'expanded' : ''}`}>
                {expanded || !isLong ? description : shortText}
            </p>
            {isLong && (
                <span
                    onClick={toggleExpand}
                    style={{ color: "#3498db", cursor: "pointer", fontSize: "14px" }}
                >
                    {expanded ? "Read Less" : "Read More"}
                </span>
            )}
        </div>
    );
};
